import React, { useEffect, useState } from "react";
import Classes from "./styles/style.module.css";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import LigPodium from "./LigPodium";
import LigRateList from "./ligRatingList";
import LeaderBoardMessages from "./LeaderBoardMessages";

const LigLeaderBoard = () => {
  const [data, setData] = useState(null);
  const [showMessages, setShowMessages] = useState(false);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    fetch("/static_data/leaderboard_message.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.messages.length !== 0) {
          setMessages(data.messages);
          setShowMessages(true);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      });
  }, []);

  useEffect(() => {
    fetch("/static_data/leaderBoard.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setData(data.leaderboardData);
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      });
  }, []);

  return (
    <AnimatedPageContainer>
      <div className={Classes.ligContainer}>
        <LigPodium data={data ? data.slice(0, 3) : []} />
        <LigRateList
          data={data ? (data.length > 3 ? data.slice(3) : []) : []}
        />
      </div>
      <LeaderBoardMessages
        show={showMessages}
        closeHandler={() => setShowMessages(false)}
        data={messages}
      />
    </AnimatedPageContainer>
  );
};

export default LigLeaderBoard;
